export default "__VITE_ASSET__Cd$ExvZb__"